import BaseDataShape = require("./BaseDataShape");

class ConeDataShape implements BaseDataShape
{
    vertices:number[];

    indices:number[];

    constructor(radius?: number, height?:number, numSegments?:number)
    {
        radius = radius || .5;
        height = height || 1;
        numSegments = numSegments || 5;
        this.vertices = [0.0, 0.0, height];
        this.indices = [];
        var baseIndex = 1;
        var segmentRad = Math.PI * 2.0 / numSegments;

        for (var i = 0; i < numSegments; ++i) {
            var angle = segmentRad * i;
            this.vertices.push(Math.cos(angle) * radius, Math.sin(angle) * radius, 0.0);
            if (i == numSegments - 1)
                this.indices.push(0, baseIndex, 1);
            else
                this.indices.push(0, baseIndex, baseIndex+1);

            ++baseIndex;
        }
    }
}
export = ConeDataShape;